import { render, staticRenderFns } from "./Lexicon.vue?vue&type=template&id=77146640&scoped=true&"
import script from "./Lexicon.vue?vue&type=script&lang=ts&"
export * from "./Lexicon.vue?vue&type=script&lang=ts&"
import style0 from "./Lexicon.vue?vue&type=style&index=0&id=77146640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77146640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77146640')) {
      api.createRecord('77146640', component.options)
    } else {
      api.reload('77146640', component.options)
    }
    module.hot.accept("./Lexicon.vue?vue&type=template&id=77146640&scoped=true&", function () {
      api.rerender('77146640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/form/Lexicon.vue"
export default component.exports